import { Button, Modal } from "@bcc-ui/ui-components";
import React from "react";
import { useTranslation } from "react-i18next";

interface Props {
    isOpen: boolean;
    hideModal: () => void;
    title: React.ReactNode;
    message: React.ReactNode;
    isLoading: boolean;
}

export const SuccessModal = (props: Props) => {
    const { t } = useTranslation();
    return (
        <Modal
            isOpen={props.isOpen}
            hideModal={props.hideModal}
            title={props.title}
            isLoading={props.isLoading}
            buttons={
                !props.isLoading && (
                    <Button variant={"Primary"} onClick={props.hideModal}>
                        {t("Common.ok")}
                    </Button>
                )
            }
        >
            {props.message}
        </Modal>
    );
};
